import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ThumbDownIcon(props: IconProps) {
    return <Icon {...props} iconKey={"thumb_down"}/>
}
